<template>
  <button
    class="sf-btn"
    :class="[
      variantClass,
      smallClass,
      disabledClass,
      componentTypeClass,
      displayClass,
    ]"
    v-bind="$attrs"
    @click="handleClick"
  >
    <slot></slot>
  </button>
</template>
<script setup lang="ts">
import { computed } from 'vue'

// eslint-disable-next-line no-undef
defineOptions({
  name: 'SfButtonBase',
})

interface Props {
  variant?: string
  small?: boolean
  disabled?: boolean
  inline?: boolean
  componentType?: string | string[]
}

const props = withDefaults(defineProps<Props>(), {
  variant: '',
  componentType: 'button',
})

const emit = defineEmits(['click'])

const variantClass = computed<string>(() => `sf-btn-${props.variant}`)
const smallClass = computed<string>(() => (props.small ? 'sf-btn-small' : ''))
const disabledClass = computed<string>(() =>
  props.disabled ? 'sf-btn-disabled' : ''
)
const displayClass = computed<string>(() =>
  props.inline ? 'tw-inline-flex' : 'tw-flex'
)

const componentTypeClass = computed<string>(() => {
  if (Array.isArray(props.componentType)) {
    return props.componentType.map((type) => `sf-btn-${type}`).join(' ')
  }

  return `sf-btn-${props.componentType}`
})

function handleClick(): void {
  if (!props.disabled) {
    emit('click')
  }
}
</script>
<style scoped lang="scss">
@import 'silverfin-ui-kit/src/scss/tooling';

.sf-btn {
  font-family: $FAMILY-SANS-SERIF;
  align-items: center;
  justify-content: center;
  grid-column-gap: 4px;
}
</style>
